import { Helmet } from "react-helmet";

export default function Seo({ title, description, link }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="icon" href={link ?? "/images/favi-icon.png"} />
    </Helmet>
  );
}
